export const alertTypes = {
  ACTIVE: 'alert_active',
  CHANGE_DISPLAY_LOCATION: 'alert_change_display_location',
  INACTIVE: 'alert_inactive',
  INACTIVE_DONT_CHANGE_DISPLAY_LOCATION:
    'alert_inactive_dont_change_display_location',
};
